export const QUERY_TAXES_TAX_ESTIMATE = "QUERY_TAXES_TAX_ESTIMATE";
